import { Box, styled } from '@mui/material';

export const ModalWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  minWidth: '400px',
  padding: theme.spacing(3),
}));

export const ModalRowContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  width: '75%',
  gap: theme.spacing(2),
}));
